import React, { useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import HistoryIcon from '@mui/icons-material/History'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import ListItem from '@mui/material/ListItem'
import List from '@mui/material/List'
import Typography from '@mui/material/Typography'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import Hidden from '@mui/material/Hidden'
import { Divider } from '@mui/material'

import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded'
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded'
import { Link } from 'react-router-dom'
import INSiConfigModal from './INSiConfigModal'
import styles from '../Common/_styles/containerListStyles'
import stylesFailed from './styles/failedPatients'
import { checkPendingInsBatch, runINS } from '../../api/healthCareService'
import { displaySnackbar } from '../../actions/main'
import ButtonConfigModal from './ButtonConfigModal'
import INSIConnector from '../../utils/insi'
import useButtonsStyles from '../../styles/buttonsStyles'
import { useAppDispatch, useAppSelector } from '../../store'
import sxs from './styles/CheckBatchButton.sxs'
import FlexBox from '../Common/flexBox/FlexBox'
import { CheckBatchButtonProps } from './_props'
import NotificationWrapper from '../Common/notificationWrapper/NotificationWrapper'
import useCurrentUser from '../../hooks/useCurrentUser'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: DefaultTheme) => { patie... Remove this comment to see the full error message
const useStyles = makeStyles((theme) => ({
    ...styles(theme),
    // @ts-expect-error TS(2554) FIXME: Expected 0 arguments, but got 1.
    ...stylesFailed(theme),
}))

const CheckBatchButton: React.FC<CheckBatchButtonProps> = ({ displayNotification }) => {
    const classes = useStyles()
    const buttonsClasses = useButtonsStyles()
    const hcs = useAppSelector((state) => state.healthCareService)
    const dispatch = useAppDispatch()
    const [pendingBatch, setPendingBatch] = React.useState(false)
    const [failedPatients, setFailedPatients] = React.useState([])
    const [isDmpConnectorAlive, setIsDmpConnectorAlive] = useState(false)
    const [running, setRunning] = React.useState(false)
    const [open, setOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const [storedData, setStoredData] = useState(null)
    const user = useCurrentUser()

    React.useEffect(() => {
        checkPendingInsBatch(hcs).then((res: any) => {
            setPendingBatch(res)
        })
    }, [hcs])

    React.useEffect(() => {
        const isAlive = async () => {
            const result = await INSIConnector.checkDmpConnectJsServiceAvailable()
            setIsDmpConnectorAlive(result)
        }
        isAlive()
        setStoredData(INSIConnector.getStoredData(user))
    }, [])

    const execute = async () => {
        setRunning(true)

        try {
            const result = await runINS(hcs, setFailedPatients)
            dispatch(displaySnackbar(result.type, result.message))
        } catch (e) {
            // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
            dispatch(displaySnackbar('error', e.message))
        }

        checkPendingInsBatch(hcs).then((res: any) => {
            setRunning(false)
            setPendingBatch(res)
        })
    }

    INSIConnector.setMonitoringCpxCallback(() => {
        dispatch(displaySnackbar('error', 'La carte CPS a été retirée'))
        const data = {
            cpsCard: '',
            // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
            vitaleCard: storedData.vitaleCard,
            pin: '',
            // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
            expire: storedData.expire,
        }
        INSIConnector.setStoredData(user, data)
        // @ts-expect-error TS(2345) FIXME: Argument of type '{ cpsCard: string; vitaleCard: a... Remove this comment to see the full error message
        setStoredData(data)
        setOpen(false)
        dispatch(
            displaySnackbar(
                'error',
                'Carte CPS absente, veuillez réintroduire votre carte CPS et saisir le code porteur !',
            ),
        )
    })

    const failedPatientsErrors = failedPatients.reduce((res, current) => {
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        res[current.error] = res[current.error] || []
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        res[current.error].push(current.name)
        return res
    }, {})

    return (
        <>
            <NotificationWrapper active={displayNotification}>
                <Button
                    className={buttonsClasses.ButtonTextBlack}
                    startIcon={<MoreVertRoundedIcon />}
                    // @ts-expect-error TS(2345) FIXME: Argument of type 'EventTarget & HTMLButtonElement'... Remove this comment to see the full error message
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                >
                    <Hidden smDown>INS</Hidden>
                </Button>
            </NotificationWrapper>
            <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                <FlexBox sx={sxs.CheckBatchButtonMenu} gap=".5rem" flexDirection="column">
                    <ButtonConfigModal
                        withLabel
                        onClick={() => setOpen(true)}
                        storedData={storedData}
                        isDmpConnectorAlive={isDmpConnectorAlive}
                    />
                    <Divider />
                    <Button
                        disabled={!displayNotification}
                        startIcon={<PendingActionsRoundedIcon />}
                        endIcon={<ChevronRightRoundedIcon />}
                        color="inherit"
                        component={Link}
                        to="/patients-workbench"
                    >
                        <NotificationWrapper
                            active={displayNotification}
                            bubbleProps={{
                                size: '.7rem',
                            }}
                        >
                            Liste des identités en attente de traitement
                        </NotificationWrapper>
                    </Button>
                    <Divider />
                    <Button
                        color="primary"
                        disabled={
                            // @ts-expect-error TS(2339) FIXME: Property 'cpsCard' does not exist on type 'never'.
                            running || !storedData || !storedData.cpsCard || !storedData.pin || !isDmpConnectorAlive
                        }
                        onClick={execute}
                        startIcon={<HistoryIcon />}
                    >
                        {!pendingBatch && <Hidden smDown>VÉRIFIER INS PAR LOT</Hidden>}
                        {pendingBatch && <Hidden smDown>RÉCUPÉRER VÉRIFICATION INS</Hidden>}
                    </Button>
                </FlexBox>
            </Menu>
            <Dialog open={running}>
                <DialogTitle>Opération en cours</DialogTitle>
                <DialogContent>
                    {!pendingBatch && (
                        <DialogContentText>
                            Veuillez patienter jusqu'à la fin de la création des lots et ne pas fermer la fenêtre
                        </DialogContentText>
                    )}
                    {pendingBatch && (
                        <DialogContentText>
                            Veuillez patienter jusqu'à la fin de la vérification et ne pas fermer la fenêtre
                        </DialogContentText>
                    )}
                </DialogContent>
            </Dialog>
            {open && <INSiConfigModal onClose={() => setOpen(false)} onStoredDataChange={setStoredData} />}
            {failedPatients && failedPatients.length > 0 && (
                <Dialog open>
                    {/* @ts-expect-error TS(2339) FIXME: Property 'patientErrorDialogTitle' does not exist ... Remove this comment to see the full error message */}
                    <DialogTitle className={classes.patientErrorDialogTitle}>
                        {/* @ts-expect-error TS(2339) FIXME: Property 'patientErrorDialogTitleIcon' does not ex... Remove this comment to see the full error message */}
                        <ErrorOutlineRoundedIcon className={classes.patientErrorDialogTitleIcon} />
                        {/* @ts-expect-error TS(2339) FIXME: Property 'patientErrorDialogTitleText' does not ex... Remove this comment to see the full error message */}
                        <span className={classes.patientErrorDialogTitleText}>
                            Des patients ne peuvent être envoyés
                        </span>
                    </DialogTitle>
                    <DialogContent>
                        {/* @ts-expect-error TS(2339) FIXME: Property 'patientError' does not exist on type 'Cl... Remove this comment to see the full error message */}
                        <div className={classes.patientError}>
                            {Object.keys(failedPatientsErrors).map((type, index) => {
                                // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                                const patients = failedPatientsErrors[type]
                                const key = `key-${index}`

                                return (
                                    // @ts-expect-error TS(2339) FIXME: Property 'patientErrorSection' does not exist on t... Remove this comment to see the full error message
                                    <div key={key} className={classes.patientErrorSection}>
                                        {/* @ts-expect-error TS(2339) FIXME: Property 'patientErrorSectionTitle' does not exist... Remove this comment to see the full error message */}
                                        <Typography className={classes.patientErrorSectionTitle}>
                                            {type === 'MISSING_BASE' &&
                                                'Une ou plusieurs informations du patient sont manquantes'}
                                            {type === 'WRONG_INS' && 'Le matricule INS du patient est incorrect'}
                                            {type === 'WRONG_AGE' && 'L’âge du patient est incorrect'}
                                            {type === 'INCORRECT_FIRSTNAME' &&
                                                'Le prénom de naissance du patient est incorrect'}
                                            {type === 'INCORRECT_NAME' &&
                                                'Le nom de naissance du patient est incorrect'}
                                        </Typography>
                                        {/* @ts-expect-error TS(2339) FIXME: Property 'patientErrorSection' does not exist on t... Remove this comment to see the full error message */}
                                        <div className={classes.patientErrorSection}>
                                            <List>
                                                {patients &&
                                                    patients.map((patient: any, subIndex: any) => {
                                                        const subkey = `key-${subIndex}`
                                                        return (
                                                            <ListItem
                                                                key={subkey}
                                                                // @ts-expect-error TS(2339) FIXME: Property 'patientErrorSectionListItem' does not ex... Remove this comment to see the full error message
                                                                className={classes.patientErrorSectionListItem}
                                                            >
                                                                {patient}
                                                            </ListItem>
                                                        )
                                                    })}
                                            </List>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            // @ts-expect-error TS(2339) FIXME: Property 'button' does not exist on type 'ClassNam... Remove this comment to see the full error message
                            className={classes.button}
                            variant="outlined"
                            color="primary"
                            onClick={() => setFailedPatients([])}
                        >
                            Fermer
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    )
}

export default CheckBatchButton
